import {
	BulkRequest,
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
} from "@dgs/core";
import axios from "axios";
import {
	CreateRequest,
	DeclineFormValues,
	DeclineRequest,
	EventUserRequestApprovedIndexResource,
	EventUserRequestOpenIndexResource,
} from "../types/eventUserRequest";

const baseKey = ["event-user-requests"];
const openRequestsKey = [...baseKey, "open"];
const approvedRequestsKey = [...baseKey, "approved"];
const bulkApproveRequestsKey = [...baseKey, "bulk-approve"];
const bulkDeclineRequestsKey = [...baseKey, "bulk-decline"];
const approveRequestKey = (eventUserRequestId: Id) => [...baseKey, `${eventUserRequestId}`, "approve"];
const declineRequestKey = (eventUserRequestId: Id) => [...baseKey, `${eventUserRequestId}`, "decline"];

export const eventUserRequestService = {
	indexOpenRequests: (config: PaginatedListFetcherConfig<any>) =>
		axios.get<LaravelResponse<EventUserRequestOpenIndexResource[]>>(keyToUrl(openRequestsKey), {
			params: { ...mapPaginatedFetcherConfigToAxiosConfig(config).params, orderBy: config.sortParams },
		}),
	openRequestsKey,
	indexApprovedRequests: (config: PaginatedListFetcherConfig<any>) =>
		axios.get<LaravelResponse<EventUserRequestApprovedIndexResource[]>>(keyToUrl(approvedRequestsKey), {
			params: { ...mapPaginatedFetcherConfigToAxiosConfig(config).params, orderBy: config.sortParams },
		}),
	approvedRequestsKey,
	approveRequest: (eventRequestId: Id) => axios.put<LaravelResponse<any>>(keyToUrl(approveRequestKey(eventRequestId))),
	approveRequestKey,
	declineRequest: (eventRequestId: Id, request: DeclineRequest) =>
		axios.post<LaravelResponse<any>>(keyToUrl(declineRequestKey(eventRequestId)), { data: request }),
	declineRequestKey,
	bulkApproveRequests: (request: BulkRequest) => axios.put(keyToUrl(bulkApproveRequestsKey), request),
	bulkApproveRequestsKey,
	bulkDeclineRequests: (request: BulkRequest & DeclineFormValues) =>
		axios.put(keyToUrl(bulkDeclineRequestsKey), request),
	bulkDeclineRequestsKey,
	createRequest: (request: CreateRequest) => axios.post<LaravelResponse<any>>(keyToUrl(baseKey), request),
};
